import type { ClassValue } from "cnfast";
import { clsx, clsx as type, twMerge } from "cnfast";

/**
 *
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

/**
 *
 */
export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

// The error pipeline (logger, Sentry, PostHog) and the toast are imported on
// first use, not at module load: every component imports `cn` from this file,
// so static imports put all of them in the first-load bundle of every page.
/**
 *
 */
export const handleError = (error: unknown): void => {
  Promise.all([
    import("@nyntax/observability/error"),
    import("@nyntax/design-system/components/ui/toast"),
  ])
    .then(([{ parseError }, { toastManager }]) => {
      const message = parseError(error);
      toastManager.add({ id: "global-error", title: message, type: "error" });
    })
    .catch(() => {
      // Reporting itself failed to load; nothing further to surface.
    });
};

// Tremor focusInput [v0.0.2]

export const focusInput = [
  // base
  "focus:ring-2",
  // ring color
  "focus:ring-blue-200 dark:focus:ring-blue-700/30",
  // border color
  "focus:border-blue-500 dark:focus:border-blue-700",
];

// Tremor Raw focusRing [v0.0.1]

export const focusRing = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-blue-500 dark:outline-blue-500",
];

// Tremor Raw hasErrorInput [v0.0.1]

export const hasErrorInput = [
  // base
  "ring-2",
  // border color
  "border-red-500 dark:border-red-700",
  // ring color
  "ring-red-200 dark:ring-red-700/30",
];
